// @flow

import { object, string, boolean } from 'yup'
import type { Schema } from 'yup'
import type { FormData } from '../../types'

const phoneSchemaRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const ContactSchema: Schema<FormData, any> = object().shape({
  'form-name': string().matches(/(contact)/),
  firstName: string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('You must enter a first name.'),
  lastName: string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('You must enter a last name.'),
  email: string()
    .email('The email you entered is invalid.')
    .required('You must enter an email so we are able to contact you.'),
  phone: string().matches(
    phoneSchemaRegExp,
    'The phone number you entered is not valid. (eg. 123-555-1234)',
  ),
  message: string(),
  hasOptedIn: boolean(),
  botField: string(),
})

export default ContactSchema
